import {
  Bell,
  Collection,
  Cpu,
  Document,
  Files,
  House,
  List,
  Checked,
  DataAnalysis,
  Promotion,
  Search,
  Setting,
  UserFilled,
  VideoCamera,
} from "@element-plus/icons-vue";
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useSystemContextStore } from "@/stores/system-context";

export function useNavigationItems() {
  const auth = useAuthStore();
  const systemContext = useSystemContextStore();
return computed(() => [
  { path: "/dashboard", label: "工作台", icon: House },
  { path: "/company-operations", label: "经营总览", icon: DataAnalysis },
  { path: "/work-items", label: "我的工作", icon: Checked },
  { path: "/projects", label: "项目管理", icon: Files },
  ...(auth.can("contract:view")
    ? [{ path: "/contracts", label: "合同管理", icon: Document }]
    : []),
  ...(systemContext.features.crm && auth.can("customer:view")
    ? [
        { path: "/crm", label: "客户经营", icon: UserFilled },
        { path: "/meetings", label: "会议与沟通", icon: VideoCamera },
      ]
    : []),
  ...(auth.can("issue:create")
    ? [{ path: "/intake", label: "信息准入中心", icon: Collection }]
    : []),
  { path: "/issues", label: "问题管理", icon: List },
  ...(auth.can("release_version:view")
    ? [{ path: "/release-versions", label: "发布版本管理", icon: Promotion }]
    : []),
  ...(auth.can("ai:analyze")
    ? [
        { path: "/ai/search", label: "智能检索", icon: Search },
        { path: "/ai", label: "AI分析中心", icon: Cpu },
      ]
    : []),
  ...(auth.can("report:view")
    ? [{ path: "/reports", label: "工作报告", icon: Document }]
    : []),
  { path: "/notifications", label: "提醒中心", icon: Bell },
  ...(auth.can("system:manage")
    ? [{ path: "/system", label: "系统管理", icon: Setting }]
    : []),
]);
}
